<template>
  <CardToolbox>
    <sdPageHeader title="Templates">
      <template #subTitle>
        <span class="title-counter">{{ count }} template{{ count > 0 && count < 2 ? '' : 's' }}</span>
        <AutoCompleteStyled style="width:100%" placeholder="Zoeken op naam...">
          <a-input type="input" v-model:value="search">
            <template #suffix>
              <sdFeatherIcons type="search"/>
            </template>
          </a-input>
        </AutoCompleteStyled>
      </template>
      <template #buttons>
        <TemplateAdd v-if="$can('create', 'productcommunicationtemplate')"/>
      </template>
    </sdPageHeader>
  </CardToolbox>

  <Main>
    <a-row :gutter="15">
      <a-col :md="24">
        <TemplateTable/>
      </a-col>
    </a-row>
  </Main>
</template>
<script>
import TemplateTable from './component/TemplateTable';
import {computed, ref, defineComponent, onMounted, watch} from 'vue';
import {useStore} from 'vuex';
import {Main, CardToolbox, AutoCompleteStyled} from '../styled';
import TemplateAdd from "./TemplateAdd";

const TemplateList = defineComponent({
  name: 'TemplateList',
  components: {TemplateAdd, Main, CardToolbox, TemplateTable, AutoCompleteStyled},
  setup() {
    const {state, dispatch} = useStore();
    const count = computed(() => state.productCommunicationTemplate.count);
    const selectedRowKeys = ref(0);
    const selectedRows = ref(0);
    const search = ref(state.productCommunicationTemplate.listQuery?.q ?? null);
    let debounce = null;

    watch(search, (query) => {
      clearTimeout(debounce)
      debounce = setTimeout(async () => {
        const searchValues = {
          q: query,
          pageSize: state.productCommunicationTemplate.pageSize,
          page: 1,
        };
        await dispatch('setCurrentPageTemplates', 1);
        await dispatch('getTemplates', searchValues);
      }, 600);
    });

    onMounted(() => {
      window.scrollTo(0, 0);
      dispatch('getTemplates', {page: state.productCommunicationTemplate.currentPage, pageSize: state.productCommunicationTemplate.pageSize});
    });

    return {
      selectedRowKeys,
      selectedRows,
      count,
      search,
    };
  },
});

export default TemplateList;
</script>

